import React, { Component } from "react";

import "../resources.css";

class Resources extends Component {
 render() {
  return (
   <>
    <div className="Resources">
     <h1 className="heading">Resources</h1>
     <div className="box">
      The objective of this page is to help people gain access to vital resources by sharing information only.
      However, we request the beneficiaries to use their discretion and verify the leads on their own before
      taking any action. If you find inaccurate information or any lead engaging in illegal practices, kindly
      inform us at hello@covid19india.org. We will take it down as soon as possible. We will not be
      responsible for the actions you take using the information on this page. We are just mediating
      information and are no way responsible for what is being shared. Please avoid sharing and contacting
      black market resources. We strongly encourage to AVOID black market.
     </div>
     <div className="resources">
      <a href="https://life.coronasafe.network/" target="_noblank" className="resource">
       <div className="title">Covidfyi - Pan India</div>
       <div className="link">https://life.coronasafe.network/</div>
      </a>
      <a
       href="https://www.factchecker.in/fact-check/factchecker-verified-covid-19-helplines-remdesivir-hospital-beds-oxygen-743175"
       target="_noblank"
       className="resource"
      >
       <div className="title">Factchecker - Pan India</div>
       <div className="link">
        https://www.factchecker.in/fact-check/factchecker-verified-covid-19-helplines-remdesivir-hospital-beds-oxygen-743175
       </div>
      </a>
      <a
       href="https://docs.google.com/spreadsheets/d/1OL7go19rRpSdxemQXHM0cTBds2hjspj7_U7Ag7NdOCQ/edit#gid=92299482"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://docs.google.com/spreadsheets/d/1OL7go19rRpSdxemQXHM0cTBds2hjspj7_U7Ag7NdOCQ/edit#gid=92299482
       </div>
      </a>
      <a
       href="https://docs.google.com/document/d/16WeMKah7RXoB1gnqa9YXVTuWM4TR6hY9Qys48Pf8mCc/edit?usp=drivesdk"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://docs.google.com/document/d/16WeMKah7RXoB1gnqa9YXVTuWM4TR6hY9Qys48Pf8mCc/edit?usp=drivesdk
       </div>
      </a>
      <a href="www.covidfacts.in" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">www.covidfacts.in</div>
      </a>
      <a
       href="https://docs.google.com/spreadsheets/d/1J2kObssgqNH0cpIZcjkdc8szhlz9pJazTMFyQ-fDo_A/edit#gid=1745413321"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://docs.google.com/spreadsheets/d/1J2kObssgqNH0cpIZcjkdc8szhlz9pJazTMFyQ-fDo_A/edit#gid=1745413321
       </div>
      </a>
      <a
       href="https://drive.google.com/drive/u/0/mobile/folders/1y8fjrbdGEGmcStkNE_Jf5sNRaDCY4zRA"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://drive.google.com/drive/u/0/mobile/folders/1y8fjrbdGEGmcStkNE_Jf5sNRaDCY4zRA
       </div>
      </a>
      <a href="https://linktr.ee/Okayival" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">https://linktr.ee/Okayival</div>
      </a>
      <a
       href="https://external.sprinklr.com/insights/explorer/dashboard/601b9e214c7a6b689d76f493/tab/4?id=DASHBOARD_601b9e214c7a6b689d76f493&amp;home=1"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://external.sprinklr.com/insights/explorer/dashboard/601b9e214c7a6b689d76f493/tab/4?id=DASHBOARD_601b9e214c7a6b689d76f493&amp;home=1
       </div>
      </a>
      <a href="https://covid19.nalsar.ac.in/crowdsourced-data/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">https://covid19.nalsar.ac.in/crowdsourced-data/</div>
      </a>
      <a
       href="https://docs.google.com/spreadsheets/d/1OL7go19rRpSdxemQXHM0cTBds2hjspj7_U7Ag7NdOCQ/htmlview"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://docs.google.com/spreadsheets/d/1OL7go19rRpSdxemQXHM0cTBds2hjspj7_U7Ag7NdOCQ/htmlview
       </div>
      </a>
      <a href="https://www.theuncutteam.com/covidresources" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">https://www.theuncutteam.com/covidresources</div>
      </a>
      <a
       href="https://docs.google.com/spreadsheets/d/1-HDRXAnMGkFIr8HQB_fUaZiL70c-rSuShYYfO2U6754/edit#gid=1554547770"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://docs.google.com/spreadsheets/d/1-HDRXAnMGkFIr8HQB_fUaZiL70c-rSuShYYfO2U6754/edit#gid=1554547770
       </div>
      </a>
      <a href="https://indiacovidresources.in/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">https://indiacovidresources.in/</div>
      </a>
      <a
       href="https://covidfood.retool.com/embedded/public/57eb2d29-47b4-4322-aadf-83cf368d2990/"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://covidfood.retool.com/embedded/public/57eb2d29-47b4-4322-aadf-83cf368d2990/
       </div>
      </a>
      <a
       href="http://friends2support.org/inner/news/searchresult.aspx"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">http://friends2support.org/inner/news/searchresult.aspx</div>
      </a>
      <a href="https://covidfightclub.org/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">https://covidfightclub.org/</div>
      </a>
      <a
       href="https://docs.google.com/spreadsheets/d/e/2PACX-1vQyasU1SAeicUEkSbz9Nfxdt2hdas6-5cdcO1S30uNIqQ53pX3aHxW8FC4pGVOiJlseVDK5k6T2vuUc/pubhtml?widget=true&amp;headers=false"
       target="_noblank"
       className="resource"
      >
       <div className="title">Independent aggregator - Pan India</div>
       <div className="link">
        https://docs.google.com/spreadsheets/d/e/2PACX-1vQyasU1SAeicUEkSbz9Nfxdt2hdas6-5cdcO1S30uNIqQ53pX3aHxW8FC4pGVOiJlseVDK5k6T2vuUc/pubhtml?widget=true&amp;headers=false
       </div>
      </a>
      <a href="https://covidbihar.com/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Bihar</div>
       <div className="link">https://covidbihar.com/</div>
      </a>
      <a href="https://covidpune.com/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Pune</div>
       <div className="link">https://covidpune.com/</div>
      </a>
      <a href="https://covid-sos-4034.glideapp.io/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Punjab</div>
       <div className="link">https://covid-sos-4034.glideapp.io/</div>
      </a>
      <a href="https://linktr.ee/b4ls1r210" target="_noblank" className="resource">
       <div className="title">Independent aggregator - West Bengal</div>
       <div className="link">https://linktr.ee/b4ls1r210</div>
      </a>
      <a href="https://covid.wechaar.com/" target="_noblank" className="resource">
       <div className="title">Independent aggregator - Delhi and Mumbai</div>
       <div className="link">https://covid.wechaar.com/</div>
      </a>
     </div>
    </div>
   </>
  );
 }
}
export default Resources;
